import {Component} from '@angular/core';
import {TranslatePipe} from "ng2-translate/ng2-translate";


@Component({
  templateUrl: 'build/pages/route/route.html',
  pipes: [TranslatePipe]
})
export class RoutePage {
  constructor() {

  }
}
